/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Section_ButtonInputs */

const fr_add_section_button = /** @type {(inputs: Add_Section_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une section`)
};

/**

* @param {Add_Section_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const add_section_button = /** @type {((inputs?: Add_Section_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Section_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_add_section_button(inputs)
});